<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت موقعیت
                    <button data-menu="HelpMenu" class="position-static mr-2"><i class="fa fa-question-circle helpIco"></i></button>

                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">

                    <div>
                        <button class="btn btn-xxs mb-2 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="getCurrentPosition">
                            <i class="fa fa-map-marker-alt font-10 ml-2"></i>
                            دریافت موقعیت
                        </button>
                        <p class="text-danger" v-if="v$.userPresenceModel.mapLocation.required.$invalid && v$.userPresenceModel.mapLocation.$dirty">موقعیت جغرافیایی مشخص نشده است.</p>
                    </div>


                    <div class="mb-4">
                        <l-map style="height:300px" :zoom="16" :center="mapLocationObject" v-if="mapLocationObject!=null">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="mapLocationObject"></l-marker>
                        </l-map>
                    </div>



                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-calendar color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.presenceDate!==null}">تاریخ </span>
                        <input type="text"
                               class="form-control ltr d-inline-block"
                               v-model="userPresenceModel.presenceDate"
                               id="endDT" />
                    </div>



                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-file-alt color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">نوع :</span>
                        <select class="form-control" type="text" v-model="userPresenceModel.userPresenceTypeId" @change="setTitle">
                            <option value=0>ثبت موقعیت</option>
                            <option value=1>ورود</option>
                            <option value=2>خروج</option>
                        </select>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check color-magenta2-light"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="userPresenceModel.title" @input="v$.userPresenceModel.title.$touch()" :class="{invalid:v$.userPresenceModel.title.$error}">
                        <p class="text-danger" v-if="v$.userPresenceModel.title.required.$invalid && v$.userPresenceModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>

                    <div class="card mx-0 mb-3">
                        <div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>

                        <div class="collapse collapse-reminderCalendars" id="collapse-description">
                            <textarea v-model="userPresenceModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px"></textarea>

                        </div>
                    </div>
                    <att-list v-bind:destination="'UserPresence'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="false"></att-list>

                    <button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateUserPresence">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                    <!--<button type="button" v-if="isAutomaticStart==false" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="StartAutomatic">
                        <i class="fa fa-check font-10 ml-2"></i>
                        شروع موقعیت اتوماتیک
                    </button>
                    <button type="button" v-if="isAutomaticStart==true" class="btn btn-xxs mt-2 mb-3 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="StopAutomatic">
                        <i class="fa fa-check font-10 ml-2"></i>
                        توقف موقعیت اتوماتیک
                    </button>-->
                </div>
            </div>
        </div>
        <date-picker type="date" v-model="userPresenceModel.presenceDate" format="jYYYY/jMM/jDD" element="endDT" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال ارسال اطلاعات ...</div>
            </div>
        </transition>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <!--<div id="userPresenceHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import DatePicker from 'vue3-persian-datetime-picker';
    import HelpMenu from '../Components/HelpMenu.vue';
    import "leaflet/dist/leaflet.css"
    import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
    import { Device } from '@capacitor/device';
    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    import { Icon } from 'leaflet';
    import VueSimpleAlert from 'vue3-simple-alert';


    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    export default {
        components: {
            DatePicker,
            "att-list": AttList,
            LMap,
            LMarker,
            "Help-Menu": HelpMenu,
            LTileLayer
        },
        setup: () => ({ v$: useVuelidate() }),
        data() {
            return {
                attInProgress: false,
                modified: false,
                isAutomaticStart: false,
                isAutomatic: false,
                logDeviceInfo: null,
                mapLocationObject: null,
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                userPresenceModel: {
                    title: null,
                    userPresenceId: 0,
                    userId: 0,
                    isAutomatic: false,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    presenceDate: null,
                    mapLocation: null,
                    countryTitle: null,
                    goBack: true,
                    cityTitle: null,
                    address: null,
                    ipAddress: null,
                    deviceInfo: " ",
                    userPresenceTypeId: 0
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            propsToWatch() {
                return `${this.userPresenceModel.title}|${this.userPresenceModel.description}`;
            },

        },
        watch: {
            propsToWatch: {
                handler: function () {
                    console.log(this.modified);
                    this.modified = true;
                },
                deep: true
            },
        },
        async created() {
            this.userPresenceModel.title = "ثبت موقعیت";
            this.getServerDateTime();
            this.getCurrentPosition();
            //this.interval = setInterval(() => this.getCurrentPosition(), 60000);
        },
        methods: {
            CreateUserPresence() {
                this.userPresenceModel.isAutomatic = false;
                this.isAutomatic = false;
                this.SendUserPresence();

            },
            SendUserPresence() {
                if (this.isAutomatic) {
                    this.userPresenceModel.isAutomatic = true;
                    this.getCurrentPosition();
                }
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateUserPresence", this.userPresenceModel);
                    this.modified = false;
                }

            },
            StartAutomatic() {
                this.isAutomatic = true;
                this.isAutomaticStart = true;
                this.userPresenceModel.isAutomatic = true;
                this.interval = setInterval(() => this.SendUserPresence(), 60000);
            },
            StopAutomatic() {
                this.isAutomatic = false;
                this.isAutomaticStart = false;
                this.userPresenceModel.isAutomatic = false;
                clearInterval(this.interval)
                //this.interval = setInterval(() => this.SendUserPresence(), 60000);
            },
            async getCurrentPosition() {
                try {
                    const coordinates = await Geolocation.getCurrentPosition({
                        enableHighAccuracy: true
                    });
                    console.log(coordinates.coords.latitude);
                    this.userPresenceModel.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                    this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
                    this.userPresenceModel.address = await this.getAddress();
                }
                catch (ex) {
                    console.log(ex);
                    this.showErrorMessage("خطا در دریافت موقعیت مکانی. لطفا از روشن بودن Location دستگاه خود مطمئن شوید و مجددا تلاش کنید.");
                }

            },
            checkLocation() {
                window.plugins.locationAccuracy.canRequest(function (canRequest) {
                    if (canRequest) {
                        window.plugins.locationAccuracy.request(function (success) {
                            console.log("Successfully requested accuracy: " + success.message);
                        }, function (error) {
                            console.error("Accuracy request failed: error code=" + error.code + "; error message=" + error.message);
                            if (error.code !== window.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                                if (window.confirm("Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?")) {
                                    window.plugins.diagnostic.switchToLocationSettings();
                                }
                            }
                        }, window.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                    } else {
                        // request location permission and try again
                    }
                });
            },
            async GetDeficeInfo() {
                this.logDeviceInfo = await Device.getInfo();

                this.userPresenceModel.deviceInfo = this.logDeviceInfo.model + " " + this.logDeviceInfo.platform + " " + this.logDeviceInfo.operatingSystem + " " + this.logDeviceInfo.osVersion + " " + this.logDeviceInfo.webViewVersion;

            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.userPresenceModel.presenceDate = data.data.split("_")[0];
                        this.userPresenceModel.createDateTime = data.data.replace("_", " ");

                    });

            },
            SetAttList(e) {
                console.log(e);
                this.userPresenceModel.attList = e;
            },
            async getAddress() {
                //this.loading = true;
                let address = "Unresolved address";
                try {
                    const { lat, lng } = this.mapLocationObject;
                    const result = await fetch(
                        `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}&accept-language=fa-IR`
                    );
                    if (result.status === 200) {
                        const body = await result.json();
                        address = body.display_name;
                    }
                } catch (e) {
                    console.error("Reverse Geocode Error->", e);
                }
                //this.loading = false;
                return address;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            setTitle() {
                if (this.userPresenceModel.userPresenceTypeId == 1) {
                    this.userPresenceModel.title = "ورود";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 2) {
                    this.userPresenceModel.title = "خروج";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 0) {
                    this.userPresenceModel.title = "ثبت موقعیت";
                }
                else {
                    this.userPresenceModel.title = "";
                }
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        async mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
            await this.GetDeficeInfo();
            document.addEventListener("deviceready", () => {
                this.checkLocation();
            });
            //setInterval(function () {
            //    console.log("342")
            //    this.getCurrentPosition();
            //}, 10000);
        },
        validations: {
            userPresenceModel: {
                title: {
                    required,
                },
                presenceDate: {
                    required
                },
                mapLocation: {
                    required
                }
            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
